module.exports = __webpack_public_path__ + "static/media/1.fc4f7669.svg";